export const Permissions = {
  create: "create:ScholarshipAndIncentive",
  read: "read:ScholarshipAndIncentive",
  list: "list:ScholarshipAndIncentive",
  update: "update:ScholarshipAndIncentive",
  delete: "delete:ScholarshipAndIncentive",
};
